<div class="banner" role="banner">
  <h1>{{ 'offers.page.title' | translate }}</h1>
</div>

<fgb-endurance-zone></fgb-endurance-zone>
